import React from "react";
import { Link } from "react-router-dom";

const FooterThree = () => {
  return (
    <footer>
      <div className="tp-footer__area black-bg">
        <div className="tp-footer">
          <div className="tp-footer__main">
            <div className="container">
              <div className="tp-footer-border pt-100 pb-70">
                <div className="pb-30 pb-70">
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="footer-logo mb-30">
                        <Link to="/">
                          <img
                            src="/assets/img/logo/logo.png"
                            alt="Arvilax Logo"
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-between">
                  <div className="col-lg-6 col-md-12 mb-30">
                    <div className="footer-widget">
                      <h4
                        className="footer-widget-title"
                        style={{ color: "#fff" }}
                      >
                        Locations
                      </h4>
                      <div className="footer-map">
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d106135.73441222424!2d-84.50270290339346!3d33.767340007699964!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5045d6993098d%3A0x66fede2f990b630b!2sAtlanta%2C%20GA%2C%20USA!5e0!3m2!1sen!2slb!4v1727458636121!5m2!1sen!2slb"
                          style={{
                            width: "100%",
                            height: "300px",
                            border: "0",
                          }}
                          allowFullScreen
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          title="Google Maps location of Atlanta, GA"
                        ></iframe>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-12 mb-30">
                    <div className="tp-footer__widget tp-footer__2 pb-30">
                      <h3 className="tp-footer__widget-title text-white">
                        Quick Links
                      </h3>
                      <ul>
                        <li>
                          <a>The Evan Grace Group</a>
                        </li>
                        <li>
                          <a
                            href="tel:+404-583-7013
"
                          >
                            404-583-7013
                          </a>
                        </li>

                        <li>
                          <span>Atlanta, Georgia United States</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="top-footer-copyright pt-30 pb-30 black-bg">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <div className="tp-copyrigh-text text-center text-white">
                        <span>
                          © {new Date().getFullYear()} Arvilax - Business
                          Consulting. All Rights Reserved.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterThree;
